import { Component, OnInit } from '@angular/core';
import {
    AuthenticationService,
    ConfigurationService,
    FeatureService,
    PortalConfigurationService,
    PortalPreferencesInterface,
    TrackingV2Service
} from '@draeger-academy/common';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
    selector: 'da-portal-home',
    templateUrl: './portal-home.component.html',
    styleUrls: ['./portal-home.component.scss'],
    standalone: false
})
export class PortalHomeComponent implements OnInit {
    public portal: string;
    public portalForTracking: string;
    private _$preferences: BehaviorSubject<PortalPreferencesInterface> = new BehaviorSubject<PortalPreferencesInterface>(null);
    private _$loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(
        private _configurationService: ConfigurationService,
        private _authenticationService: AuthenticationService,
        private _featureService: FeatureService,
        private _portalConfigurationService: PortalConfigurationService,
        private _trackingV2Service: TrackingV2Service
    ) {}

    public get preferences$(): Observable<PortalPreferencesInterface> {
        return this._$preferences.asObservable();
    }

    public get loggedIn$(): Observable<boolean> {
        return this._$loggedIn.asObservable();
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
        this._configurationService.portalPreferences$.subscribe((preferences) => {
            if (preferences) {
                this._$preferences.next(preferences);
            }
        });

        this._configurationService.currentPortal$.subscribe((portal) => {
            if (portal) {
                this.portal = portal;
                this.portalForTracking = this.portal.toUpperCase().replace(new RegExp('-', 'g'), '_');
                this._trackPage();
            }
        });

        this._authenticationService.loggedIn().subscribe((data) => {
            this._$loggedIn.next(data !== null && data.token && data.token !== '');
        });
    }

    private _trackPage() {
        this._trackingV2Service.loadTrackingScript();
        this._trackingV2Service.trackPage({
            template: 'HomePage',
            title: 'Dräger Academy Partnerportal ' + this.portalForTracking + ' | Home'
        });
    }
}
